/* Model */
class KronosLogModel extends App.Models.BaseModel {
    modelUrl = 'ukg/KronosLog';
}

App.Models.KronosLog = KronosLogModel;

/* Collection */
class KronosLogCollection extends App.Collections.BaseCollection {
    url = 'ukg/KronosLog';
    model = App.Models.KronosLog;
}

App.Collections.KronosLogs = KronosLogCollection;

/* Router */
class KronosLogRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'KronosLog';
        const model = App.Models.KronosLog;
        const collectionClass = App.Collections.KronosLogs;

        super(entityName, model, collectionClass);

        this.useStringID = true;
    }

    beforeInitializeGrid = function (form, pageLayout) {
        form.initializeGrid = function () {
            const grid = new Monet.Builder.Form.Grid(pageLayout, 'KronosLog');
            grid.getGridOptions = function () {
                const entity = 'KronosLog';
                return {
                    entity: entity,
                    columnCheckBox: {
                        show: true,
                        checkBoxEventClass: [Greenmile.KronosLog.RejectInBatch],
                        options: {
                            checkOnClickRow: true,
                            isDisabled: (row) => {
                                const item = App.Forms.KronosLog.dataProvider.getItem(row);
                                return item &&
                                  Object.keys(item.model.attributes).length &&
                                  item.model.attributes.status !== 'ERROR';
                            }
                        }
                    },
                    columnEdit: {
                        show: false
                    },
                    actions: ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS"],
                    gridActionsSelector: this.gridActionsSelector,
                    entityToActionGrid: entity,
                    gridContainner: this.gridContainerSelector,
                    headerMenu: {
                        headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
                    },
                    multiColumnSort: true,
                    multiSelect: false,
                    frozenColumn: Monet.Grid.getIndexFrozenColumn(pageLayout)
                };
            };
    
            grid.show();
        };
    }

    beforeList = () => {
        const grid = App.Forms.KronosLog.table;
    
        grid.onClick.subscribe(function (e, args) {
            const item = args.grid.getData().data[args.row];
    
            if (item.model.attributes.status === "ERROR" || item.model.attributes.status === "REJECTED") {
                const selector   = "#KronosLog",
                  scopeBlock = "#KronosLog #allContent",
                  options    = {
                      width: 600,
                      height: 400
                  };
    
                const errorCodeResource = function (code) {
                    let resource = Monet.I18n.getResourcesByKey("kronosErroCode." + code);
                    if (resource === "kronosErroCode." + code) {
                        resource = Monet.I18n.getResourcesByKey("kronosErroCode.global") + ": " + code;
                    }
                    return resource;
                };
    
                const callbacks = {
                    onAfterShowModalForm: function () {
                        const id = item.model.attributes.id;
                        Monet.Session.Grids.Route.data = new App.Collections.KronosLogs();
                        Monet.Session.Grids.Route.data.filterWithRestrictions({
                            filter: { "criteriaChain": [{ "and": [{ "attr": "id", "eq": id }] }] },
                            criteria: '{"filters":["id","statusDetail"]}',
                            success: function (data) {
                                let content = document.querySelector(selector + ' .popupFormContainer'),
                                  statusDetail = JSON.parse(data.first().attributes.statusDetail),
                                  html = "";
                                html += statusDetail.message + " " + errorCodeResource(statusDetail.errorCode) + "<br /><br />";
                                if (statusDetail.errorDetails && statusDetail.errorDetails.errorResponseElementList) {
                                    statusDetail.errorDetails.errorResponseElementList.forEach(function (it) {
                                        html += it.message + " " + errorCodeResource(it.errorCode) + "<br /><br />";
                                    });
                                }
                                content.innerHTML = html;
                            }
                        });
                    }
                };
                new Monet.Form.Modal(selector, options, callbacks, scopeBlock).showModalForm();
            }
        });
    }

}

App.Routers.KronosLog = KronosLogRouter;

